import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import ProductCTA from "@/common/components/ProductCTA"
import { ProductBanner } from "@/common/components/ProductBanner"
import { SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import SolutionCardList from "@/common/components/ProductCard/SolutionCardList"

const AllSolutionsPage = () => {
  const { t } = useTranslation(["allSolutions"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/solutions"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/solutions"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/solutions"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/solutions"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          bannerType={SolutionNames.AllSolutions}
          titleType="primary"
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
        />
        <SolutionCardList
          cards={[SolutionNames.Web3FundManagement, SolutionNames.Web3Commerce]}
        />
        <SolutionCardList cards={[SolutionNames.Defi, SolutionNames.GameFi]} />
        <ProductCTA
          title={t("CTA.title")}
          desc={t("CTA.desc")}
          primaryButton={{ text: t("CTA.button") }}
          noArrow
        />
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "allSolutions"
    ]))
  }
})

export default AllSolutionsPage
